// eslint-disable-next-line import/no-unresolved
import { driver } from 'driver.js';

/**
 * Factory com defaults SEL (PT-BR).
 * @param {Object} [overrides]
 */
export default function createSelDriver(overrides = {}) {
  return driver({
    showProgress: true,
    animate: true,
    allowClose: true,
    overlayOpacity: 0.55,
    stagePadding: 6,
    stageRadius: 6,
    progressText: '{{current}} de {{total}}',
    nextBtnText: 'Próximo',
    prevBtnText: 'Anterior',
    doneBtnText: 'Concluir',
    ...overrides,
  });
}
